import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, 
  Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation
} from '@angular/core';

import { PickedRange, RangeType } from '@shared/filters/entities/fetch-filters.response';
import { FilterTypes } from '@shared/flight-itinerary/entities/filters';
import { SECONDS_IN_HOURS } from '@flight-results/mappers/filters.mapper';
import { HotelFilterTypes } from '@shared/hotel-itinerary/hotel-filters';
import { isEmpty, isNullOrUndefined } from '@app/util/util';
import { RangeFilterPayload } from '@shared/filters/entities/range-filter';

@Component({
  selector: 'app-range-input-filter',
  templateUrl: './range-input-filter.component.html',
  styleUrls: ['./range-input-filter.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class RangeInputFilterComponent implements OnInit, OnChanges {

  @Input() label: string;
  @Input() min = 0;
  @Input() max = 0;
  @Input() type: string | null = null;
  @Input() rangeType: string = RangeType.PRICE;
  @Input() sector: string;
  @Input() isOpenBox: boolean = false;
  @Input() isHotels: boolean;
  @Input() index: number = -1;
  @Input() individualFilter: boolean = false;
  @Input() pickedRanges: PickedRange = {} as PickedRange;

  @Output() toggleIsOpenBox: EventEmitter<boolean> = new EventEmitter();
  @Output() values: EventEmitter<RangeFilterPayload> = new EventEmitter<RangeFilterPayload>();

  public pickedMinValue = 0;
  public pickedMaxValue = 0;
  public pickedValues = [];

  constructor(
    private readonly cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.load();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!isEmpty(changes?.pickedRanges?.previousValue) && isEmpty(changes?.pickedRanges?.currentValue)) {
      this.load();
    }
  }

  public toggleOpenBox(): void {
    this.toggleIsOpenBox.emit(!this.isOpenBox);
  }

  public setLabels(values: string[]): void {
    this.pickedMinValue = parseFloat(values?.[0]);
    this.pickedMaxValue = parseFloat(values?.[1]);
  }

  public setValues(values: string[]): void {
    const _values = this.rangeType === RangeType.PRICE ? values.map(value => parseInt(value)) : values;
    const resetValuestByType = this.type === FilterTypes.PriceRange || this.type === FilterTypes.DepartureTimes ||
      this.type === FilterTypes.SectorDurations || this.type === HotelFilterTypes.Price;
    if (
      resetValuestByType && parseFloat(values[0]) === parseFloat(this.min.toString()) &&
      parseFloat(values[1]) === parseFloat(this.max.toString())
    ) {
      this.values.emit({ range: [], removable: false });
    } else {
      this.values.emit({ range: _values, removable: false });
    }
  }

  private getNumberValue(input: string | number): number {
    const value = `${input}`;
    return this.type === FilterTypes.DepartureTimes ?
      (parseFloat(value.toString()) / SECONDS_IN_HOURS) : parseFloat(input.toString())
  }

  private load(): void {
    if (this.type === FilterTypes.PriceRange || this.type === HotelFilterTypes.Price) {
      this.pickedValues = this.pickedRanges?.[this.type] as number[] ?? [];
    } else {
      this.pickedValues = this.pickedRanges?.[this.type]?.[this.sector] ?? [];
    }
    this.pickedMinValue = !isNullOrUndefined(this.pickedValues?.[0]) ? this.getNumberValue(this.pickedValues[0]) : this.min;
    this.pickedMaxValue = !isNullOrUndefined(this.pickedValues?.[1]) ? this.getNumberValue(this.pickedValues[1]) : this.max;
    this.cdr.detectChanges();
  }
}
